import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_3 = { class: "mt-2 text-sm text-gray-600" }
const _hoisted_4 = { class: "mt-6 flex flex-wrap justify-end gap-3" }

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaConfirmDialog',
  props: {
    open: { type: Boolean },
    title: {},
    description: {},
    confirmLabel: {},
    isSubmitting: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const emit = __emit;

const close = () => {
    if (!props.isSubmitting) emit('close');
};

const confirm = () => {
    if (!props.isSubmitting) emit('confirm');
};

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        onClose: close
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-200",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-150",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75" }, null, -1)
            ])),
            _: 1,
            __: [0]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-200",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-150",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "w-full max-w-md rounded-lg bg-white p-6 shadow-xl" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), { class: "text-lg font-semibold text-gray-800" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.title), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_UiButton, {
                          variant: "white",
                          "text-variant": "primary",
                          onClick: close
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.confirmDialog.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_UiButton, {
                          variant: "danger",
                          "text-variant": "white",
                          disabled: _ctx.isSubmitting,
                          onClick: confirm
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.confirmLabel), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})